import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Navbar } from "./navbar";

const LegalPage = ({ documentPath, title }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(documentPath)
      .then(response => response.text())
      .then(text => setContent(text))
      .catch(error => console.error('Error loading markdown:', error));
  }, [documentPath]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <nav className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
          >
            <svg 
              className="w-4 h-4 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <article className="bg-white rounded-lg shadow-sm p-8">
          {/* Custom styles for markdown content */}
          <div className="prose prose-slate max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 pb-4 border-b">
              {title}
            </h1>
            <div className="space-y-6">
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
                components={{
                  // Customize heading styles
                  h1: ({ node, ...props }) => (
                    <h1 className="text-2xl font-bold text-gray-900 mt-8 mb-4" {...props} />
                  ),
                  h2: ({ node, ...props }) => (
                    <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3" {...props} />
                  ),
                  h3: ({ node, ...props }) => (
                    <h3 className="text-lg font-medium text-gray-900 mt-4 mb-2" {...props} />
                  ),
                  // Style paragraphs
                  p: ({ node, ...props }) => (
                    <p className="text-gray-600 leading-relaxed mb-4" {...props} />
                  ),
                  // Style lists
                  ul: ({ node, ...props }) => (
                    <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2" {...props} />
                  ),
                  ol: ({ node, ...props }) => (
                    <ol className="list-decimal list-inside text-gray-600 mb-4 space-y-2" {...props} />
                  ),
                  // Style list items
                  li: ({ node, ...props }) => (
                    <li className="text-gray-600 ml-4" {...props} />
                  ),
                  // Style links
                  a: ({ node, ...props }) => (
                    <a className="text-blue-600 hover:text-blue-800 underline" {...props} />
                  ),
                }}
              >
                {content}
              </ReactMarkdown>
            </div>
          </div>
        </article>

        {/* Footer */}
        <footer className="mt-8 text-center text-gray-500 text-sm">
          <p>Last updated: January 4, 2025</p>
        </footer>
      </main>
    </div>
  );
};

export function TermsOfService() {
  return <LegalPage documentPath="/terms-service.md" title="Terms of Service" />;
}

export function PrivacyPolicy() {
  return <LegalPage documentPath="/privacy-policy.md" title="Privacy Policy" />;
}

export default LegalPage;